$ = jQuery.noConflict()

$(document).ready(function () {
  const $form = $('#ligo-denuncia-form')
  if (!$form.length) return

  const $btn = $('#ligo-denuncia-btn')
  const $msg = $('#ligo-denuncia-msg')
  const $nameFields = $form.find('.ligo-denuncia-nombre')
  const $dropzone = $form.find('.ligo-dropzone')
  const $dzLabel = $dropzone.find('.ligo-dropzone__label')
  const $fileInput = $('#ligo-denuncia-archivo')

  const MAX_BYTES = 5 * 1024 * 1024
  const ALLOWED = ['application/pdf', 'image/jpeg', 'image/png']
  const ALLOWED_EXT = /\.(pdf|jpe?g|png)$/i

  function showMsg(text, isError) {
    $msg
      .removeClass('hidden bg-green-100 text-green-800 bg-red-100 text-red-800')
      .addClass(isError ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800')
      .text(text)
  }

  function syncNameVisibility() {
    const wantsName = $form.find('input[name="identificarse"]:checked').val() === 'si'
    $nameFields.each(function () {
      this.hidden = !wantsName
    })
  }

  function validateFile(file) {
    if (!file) return null
    if (file.size > MAX_BYTES) return 'El archivo supera los 5MB.'
    if (!ALLOWED.includes(file.type) && !ALLOWED_EXT.test(file.name)) {
      return 'Formato no permitido. Usa PDF, JPG o PNG.'
    }
    return null
  }

  function updateDropzoneLabel() {
    const file = $fileInput[0].files[0]
    if (file) {
      const sizeKb = Math.round(file.size / 1024)
      $dzLabel.text(file.name + ' · ' + sizeKb + ' KB')
      $dropzone.addClass('has-file')
    } else {
      $dzLabel.text($dzLabel.data('default'))
      $dropzone.removeClass('has-file')
    }
  }

  $form.on('change', 'input[name="identificarse"]', syncNameVisibility)
  syncNameVisibility()

  $fileInput.on('change', function () {
    const err = validateFile(this.files[0])
    if (err) {
      this.value = ''
      showMsg(err, true)
      $msg.removeClass('hidden')
    }
    updateDropzoneLabel()
  })

  $dropzone.on('dragover', function (e) {
    e.preventDefault()
    $dropzone.addClass('is-dragover')
  })
  $dropzone.on('dragleave drop', function () {
    $dropzone.removeClass('is-dragover')
  })
  $dropzone.on('drop', function (e) {
    e.preventDefault()
    const files = e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files
    if (files && files.length) {
      $fileInput[0].files = files
      $fileInput.trigger('change')
    }
  })

  $form.on('submit', function (e) {
    e.preventDefault()

    const wantsName = $form.find('input[name="identificarse"]:checked').val() === 'si'
    const nombre = ($form.find('[name="nombre"]').val() || '').trim()
    const email = ($form.find('[name="email"]').val() || '').trim()
    const descripcion = ($form.find('[name="descripcion"]').val() || '').trim()
    const file = $fileInput[0].files[0]

    if (!descripcion || descripcion.length < 20) {
      showMsg('Describe el incidente con al menos 20 caracteres.', true)
      $msg.removeClass('hidden')
      return
    }

    if (wantsName && !nombre) {
      showMsg('Ingresa tu nombre o cambia a envío anónimo.', true)
      $msg.removeClass('hidden')
      return
    }

    const fileErr = validateFile(file)
    if (fileErr) {
      showMsg(fileErr, true)
      $msg.removeClass('hidden')
      return
    }

    if (typeof window.ligoDenuncia === 'undefined') {
      showMsg('Error de configuración. Recarga la página e intenta de nuevo.', true)
      $msg.removeClass('hidden')
      return
    }

    const fd = new FormData()
    fd.append('action', 'ligo_denuncia')
    fd.append('nonce', window.ligoDenuncia.nonce)
    fd.append('identificarse', wantsName ? 'si' : 'no')
    fd.append('nombre', wantsName ? nombre : '')
    fd.append('email', wantsName ? email : '')
    fd.append('descripcion', descripcion)
    if (file) fd.append('archivo', file)

    const originalText = $btn.text()
    $btn.prop('disabled', true).text('Enviando…')
    $msg.addClass('hidden')

    $.ajax({
      url: window.ligoDenuncia.ajaxUrl,
      type: 'POST',
      data: fd,
      processData: false,
      contentType: false,
    })
      .done(function (res) {
        if (res.success) {
          showMsg(res.data.message, false)
          $form[0].reset()
          updateDropzoneLabel()
          syncNameVisibility()
        } else {
          showMsg((res.data && res.data.message) || 'Error al enviar. Intenta de nuevo.', true)
        }
      })
      .fail(function () {
        showMsg('Error de conexión. Intenta de nuevo.', true)
      })
      .always(function () {
        $msg.removeClass('hidden')
        $btn.prop('disabled', false).text(originalText)
      })
  })
})
